import { Add } from '@mui/icons-material'
import { useSelector } from 'react-redux'

import { ListHeaderActions, ListHeaderPrimaryActionButton } from '@/components/List'

import { ReadOnlyTooltip } from '@/components/smartUtils/plan/ReadOnlyTooltip'
import { selectIsTelematicsUnavailable } from '@/features/domain/account'

import { useTexts } from '../../../../hooks/useTexts'
import { useActions } from './hooks/useActions'

export function Actions() {
  const { editing, onCreate } = useActions()
  const isTelematicsUnavailable = useSelector(selectIsTelematicsUnavailable)
  const texts = useTexts()

  const tooltipTitle = isTelematicsUnavailable
    ? texts.telematicsServiceUnavailable
    : texts.addDriver

  return (
    <ListHeaderActions>
      <ReadOnlyTooltip
        placement="bottom"
        canEdit={!isTelematicsUnavailable}
        title={tooltipTitle}
        forceState="enabled"
        render={preventEditing => (
          <ListHeaderPrimaryActionButton
            disabled={preventEditing || editing || isTelematicsUnavailable}
            onClick={onCreate}
            trackId="create-driver_icon-button"
          >
            <Add />
          </ListHeaderPrimaryActionButton>
        )}
      />
    </ListHeaderActions>
  )
}
